import { render, staticRenderFns } from "./examPaper.vue?vue&type=template&id=160de310&scoped=true"
import script from "./examPaper.vue?vue&type=script&lang=js"
export * from "./examPaper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160de310",
  null
  
)

export default component.exports